import "./error.css"

import React, {Component, ErrorInfo} from 'react';
import NotFoundImage from "../../assets/logo.png";

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {hasError: false};
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        /* error catched */
        console.log("error catched")
        console.log("error", error)
        console.log("error info ", errorInfo)
        this.setState({hasError: true});
    }

    resetErrorBoundry = () => {
        this.setState((pre) => ({
            ...pre,
            hasError: !pre.hasError
        }))
    }

    render() {
        if (this.state.hasError) {
            return <ErrorTextComponent resetErrorBoundry={this.resetErrorBoundry}/>
        }

        return this.props.children;
    }
}

function ErrorTextComponent({resetErrorBoundry}: { resetErrorBoundry: any }) {
    return <div className='error-page'>
        <img src={NotFoundImage} alt='Page not found'/>
        <p className='error-msg'>
            Hiba történt!
            <button className='btn' onClick={resetErrorBoundry}>
                Oldal újratöltése
            </button>
        </p>
    </div>
}

export default ErrorBoundary;